import globals from "./globals";
import $ from "cash-dom";
import Swiper, { Navigation } from "swiper";

const layout = (function () {
    /**
     * Initialize Slider instances
     */
    $(document).ready(function () {
        if ($(".slider").length) {
            if (globals.debug) console.log("layout-slider initialized");

            var slider;
            slider = new Swiper(".swiper", {
                autoHeight: true,
                centeredSlides: true,
                // cssMode: true,
                // grabCursor: true,
                spaceBetween: 0,
                loop: false,
                slidesPerView: "auto",
                speed: 480,
                allowTouchMove: false,
                // loopedSlides: 2,
                modules: [Navigation],
                navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev",
                },
                on: {
                    slideChange: function () {
                        $(this.el).find(".slide").removeClass("on");
                        $(this.el).find(".slide").eq([this.activeIndex]).addClass("on");
                    },
                },
            });

            $(window).on("resize", function () {
                slider.init();
            });

            // slider.addEventListener("touchmove", (e) => e.preventDefault(), { passive: false });
        }
    });
})();

export default layout;
